export default __webpack_public_path__ + "static/media/raiffeisen_background_m2.d27d6cb9.jpg";